import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ParagraphStyle = styled.p.attrs(
  ({
    $color,
    $backgroundColor,
    $align,
    $fontSize,
    $textTransform,
    $letterSpacing,
    $fontStyle,
    $fontWeight,
    $fontSizeMobile,
    $rowSpacing,
    $linkColor,
    $inlineImageWidth,
  }) => ({
    $color: $color || "",
    $backgroundColor: $backgroundColor || "",
    $fontSize: $fontSize || undefined,
    $align: $align || "",
    $textTransform: $textTransform || "",
    $letterSpacing: $letterSpacing || "",
    $fontStyle: $fontStyle || "",
    $fontWeight: $fontWeight || "unset",
    $fontSizeMobile: $fontSizeMobile || undefined,
    $rowSpacing: $rowSpacing || "",
    $linkColor: $linkColor || "",
    $inlineImageWidth: $inlineImageWidth || "100%",
  })
)`
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  font-size: ${({ $fontSize }) => $fontSize};
  text-align: ${({ $align }) => $align};
  text-transform: ${({ $textTransform }) => $textTransform};
  letter-spacing: ${({ $letterSpacing, theme }) =>
    $letterSpacing && $letterSpacing !== "0"
      ? $letterSpacing
      : theme.generalLetterSpacing
        ? theme.generalLetterSpacing + "px"
        : "0px"};
  font-style: ${({ $fontStyle }) => $fontStyle};
  font-weight: ${({ $fontWeight }) => $fontWeight};
  line-height: ${({ $rowSpacing, theme }) =>
    $rowSpacing && $rowSpacing !== "1.4"
      ? $rowSpacing
      : theme.generalLineHeight || "1.4"};
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: ${({ $fontSizeMobile, $fontSize }) =>
      $fontSizeMobile ? $fontSizeMobile + "px" : $fontSize};
  }
  a {
    color: ${({ $linkColor }) => $linkColor};
  }
  img {
    width: ${({ $inlineImageWidth }) => $inlineImageWidth} !important;
  }
`;

const Paragraph = ({
  color,
  backgroundColor,
  content,
  align,
  fontSize,
  anchor,
  className,
  direction,
  textTransform,
  letterSpacing,
  fontStyle,
  fontWeight,
  fontSizeMobile,
  rowSpacing,
  linkColor,
  inlineImageWidth,
}) => {
  return (
    <ParagraphStyle
      {...(anchor ? { id: anchor } : {})}
      className={className}
      dir={direction || "auto"}
      $color={color}
      $backgroundColor={backgroundColor}
      $fontSize={fontSize}
      $align={align}
      $textTransform={textTransform}
      $letterSpacing={letterSpacing}
      $fontStyle={fontStyle}
      $fontWeight={fontWeight}
      dangerouslySetInnerHTML={{ __html: content }}
      $fontSizeMobile={fontSizeMobile ? fontSizeMobile : null}
      $rowSpacing={rowSpacing}
      $linkColor={linkColor ? linkColor : null}
      $inlineImageWidth={inlineImageWidth}
    />
  );
};

Paragraph.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  content: PropTypes.string,
  anchor: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.string,
  align: PropTypes.string,
  direction: PropTypes.string,
  textTransform: PropTypes.string,
  letterSpacing: PropTypes.string,
  fontStyle: PropTypes.string,
  fontWeight: PropTypes.number,
  fontSizeMobile: PropTypes.string,
  rowSpacing: PropTypes.string,
  linkColor: PropTypes.string,
  inlineImageWidth: PropTypes.string,
};

export default Paragraph;
